export default __webpack_public_path__ + "static/media/more-filled.54ba1add.svg";